var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (typeof _vm.currentProduct !== 'undefined')?_c('div',{staticClass:"product__product-text",class:{ 'product__product-text--loading': _vm.loading },domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }